import { FILE } from "../actions/utilities";

const INITIAL_STATE = {
  getFolderLoading: false,
  getFolderSuccess: false,
  getFolderFailure: false,
  getFolderError: null,
  addFolderLoading: false,
  addFolderSuccess: false,
  addFolderFailure: false,
  addFolderError: null,
  deleteFolderLoading: false,
  deleteFolderSuccess: false,
  deleteFolderFailure: false,
  deleteFolderError: null,
  getFileLoading: false,
  getFileSuccess: false,
  getFileFailure: false,
  getFileError: null,
  addFileLoading: false,
  addFileSuccess: false,
  addFileFailure: false,
  addFileError: null,
  deleteFileLoading: false,
  deleteFileSuccess: false,
  deleteFileFailure: false,
  deleteFileError: null,

  getFavoriteFileLoading: false,
  getFavoriteFileSuccess: false,
  getFavoriteFileFailure: false,
  getFavoriteFileError: null,
  getFavoriteFolderLoading: false,
  getFavoriteFolderSuccess: false,
  getFavoriteFolderFailure: false,
  getFavoriteFolderError: null,
  addRemoveFavoriteFolderLoading: false,
  addRemoveFavoriteFolderSuccess: false,
  addRemoveFavoriteFolderFailure: false,
  addRemoveFavoriteFolderError: null,
  addRemoveFavoriteFileLoading: false,
  addRemoveFavoriteFileSuccess: false,
  addRemoveFavoriteFileFailure: false,
  addRemoveFavoriteFileError: null,
  fileList: [],
  folderList: [],
  recentFolder: [],
  recentFile: [],
  favoriteFolder: [],
  favoriteFile: [],
  deletedFile: [],
  deletedFolder: [],
  dateSearch: "",
  wordSearch: "",
  fileListArray: [],
  fileListSearchDate: [],
  fileListSearchWord: [],
};

export const fileReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FILE.GET_FOLDER_REQUEST:
      return {
        ...state,
        getFolderLoading: true,
        grtFolderSuccess: false,
        getFolderFailure: false,
        getFolderError: null,
      };
    case FILE.GET_FOLDER_SUCCESS:
      return {
        ...state,
        getFolderLoading: false,
        getFolderSuccess: true,
        getFolderFailure: false,
        getFolderError: null,
        folderList: action.payload,
        // fileListArray: action.payload,
        // fileListSearchDate: [],
        // fileListSearchWord: [],
        // dateSearch: "",
        // wordSearch: "",
      };
    case FILE.GET_FOLDER_FAILURE:
      let getFolderList = [];
      if (action?.payload?.folderList?.length > 0) {
        getFolderList = action.payload;
      }
      return {
        ...state,
        getFolderLoading: false,
        grtFolderSuccess: false,
        getFolderFailure: true,
        folderList: getFolderList,
        getFileError: action.payload,
      };
    case FILE.ADD_FOLDER_REQUEST:
      return {
        ...state,
        addFolderLoading: true,
        addFolderSuccess: false,
        addFolderFailure: false,
        addFolderError: null,
      };
    case FILE.ADD_FOLDER_SUCCESS:
      var addFolder = state?.folderList?.folderList;
      addFolder?.push(action.payload);
      return {
        ...state,
        addFolderLoading: false,
        addFolderSuccess: true,
        addFolderFailure: false,
        addFolderError: null,
        folderList: addFolder,
        // fileListArray: addFolder,
      };
    case FILE.ADD_FOLDER_FAILURE:
      return {
        ...state,
        addFolderLoading: false,
        addFolderSuccess: false,
        addFolderFailure: true,
        addFolderError: action.payload,
      };
    case FILE.GET_RECENT_FOLDER_REQUEST:
      return {
        ...state,
        getFileLoading: true,
        getFileSuccess: false,
        getFileFailure: false,
        getFileError: null,
      };
    case FILE.GET_RECENT_FOLDER_SUCCESS:
      return {
        ...state,
        getFileLoading: true,
        getFileSuccess: false,
        getFileFailure: false,
        recentFolder: action.payload,
        getFileError: null,
      };
    case FILE.GET_RECENT_FOLDER_FAILURE:
      return {
        ...state,
        getFileLoading: false,
        getFileSuccess: false,
        getFileFailure: true,
        getFileError: action.payload,
      };
    case FILE.GET_FAVORITE_FOLDER_REQUEST:
      return {
        ...state,
        getFavoriteFolderLoading: true,
        getFavoriteFolderSuccess: false,
        getFavoriteFolderFailure: false,
        getFavoriteFolderError: null,
      };
    case FILE.GET_FAVORITE_FOLDER_SUCCESS:
      return {
        ...state,
        getFavoriteFolderLoading: false,
        getFavoriteFolderSuccess: true,
        getFavoriteFolderFailure: false,

        favoriteFolder: action.payload,
        getFavoriteFolderError: null,
      };
    case FILE.GET_FAVORITE_FOLDER_FAILURE:
      return {
        ...state,
        getFavoriteFolderLoading: false,
        getFavoriteFolderSuccess: false,
        getFavoriteFolderFailure: true,
        getFavoriteFolderError: action.payload,
      };
    case FILE.ADD_REMOVE_FAVORITE_FOLDER_REQUEST:
      return {
        ...state,
        addRemoveFavoriteFolderLoading: true,
        addRemoveFavoriteFolderSuccess: false,
        addRemoveFavoriteFolderFailure: false,
        addRemoveFavoriteFolderError: null,
      };
    case FILE.ADD_REMOVE_FAVORITE_FOLDER_SUCCESS:
      let favFolder = state?.folderList?.folderList;
      var obj = action.payload.isActive;
      for (var i = 0; i < favFolder?.length; i++) {
        if (
          favFolder[i].documentFolderId === action.payload?.organizationFolderId
        ) {
          favFolder[i] = { ...favFolder[i], isFavFolder: obj };
        }
      }
      return {
        ...state,
        addRemoveFavoriteFolderLoading: false,
        addRemoveFavoriteFolderSuccess: true,
        addRemoveFavoriteFolderFailure: false,
        addRemoveFavoriteFolderError: null,
        favoriteFolder: favFolder,
      };
    case FILE.ADD_REMOVE_FAVORITE_FOLDER_FAILURE:
      return {
        ...state,
        addRemoveFavoriteFolderLoading: false,
        addRemoveFavoriteFolderSuccess: false,
        addRemoveFavoriteFolderFailure: true,
        addRemoveFavoriteFolderError: action.payload,
      };

    case FILE.DELETE_FOLDER_REQUEST:
      return {
        ...state,
        deleteFolderLoading: true,
        deleteFolderSuccess: false,
        deleteFolderFailure: false,
        deleteFolderError: null,
      };
    case FILE.DELETE_FOLDER_SUCCESS:
      let delfolder = state?.folderList?.folderList;
      let folderPayload = delfolder.filter(
        (item) => item.documentFolderId != action.payload
      );
      return {
        ...state,
        deleteFolderLoading: false,
        deleteFolderSuccess: true,
        deleteFolderFailure: false,
        deleteFolderError: null,
        folderList: folderPayload,
      };
    case FILE.DELETE_FOLDER_FAILURE:
      return {
        ...state,
        deleteFolderLoading: false,
        deleteFolderSuccess: false,
        deleteFolderFailure: true,
        deleteFolderError: action.payload,
      };
    case FILE.GET_DELETED_FOLDER_REQUEST:
      return {
        ...state,
        getFileLoading: true,
        getFileSuccess: false,
        getFileFailure: false,
        getFileError: null,
      };
    case FILE.GET_DELETED_FOLDER_SUCCESS:
      return {
        ...state,
        getFileLoading: true,
        getFileSuccess: false,
        getFileFailure: false,
        deletedFolder: action.payload,
        getFileError: null,
      };
    case FILE.GET_DELETED_FOLDER_FAILURE:
      return {
        ...state,
        getFileLoading: false,
        getFileSuccess: false,
        getFileFailure: true,
        getFileError: action.payload,
      };
    case FILE.GET_FILE_REQUEST:
      return {
        ...state,
        getFileLoading: true,
        getFileSuccess: false,
        getFileFailure: false,
        getFileError: null,
      };
    case FILE.GET_FILE_SUCCESS:
      return {
        ...state,
        getFileLoading: false,
        getFileSuccess: true,
        getFileFailure: false,
        getFileError: null,
        fileList: action.payload,
      };
    case FILE.GET_FILE_FAILURE:
      let List = [];
      if (action?.payload?.length > 0) {
        List = action.payload;
      }
      return {
        ...state,
        getFileLoading: false,
        getFileSuccess: false,
        getFileFailure: true,
        fileList: List,
        getFileError: action.payload,
      };
    case FILE.ADD_FILE_REQUEST:
      return {
        ...state,
        addFileLoading: true,
        addFileSuccess: false,
        addFileFailure: false,
        addFileError: null,
      };
    case FILE.ADD_FILE_SUCCESS:
      let allFileList = state.fileList;
      allFileList?.push(action.payload);
      return {
        ...state,
        addFileLoading: false,
        addFileSuccess: true,
        addFileFailure: false,
        addFileError: null,
        fileList: allFileList,
      };
    case FILE.ADD_FILE_FAILURE:
      return {
        ...state,
        addFileLoading: false,
        addFileSuccess: false,
        addFileFailure: true,
        addFileError: action.payload,
      };
    case FILE.GET_RECENT_FILE_REQUEST:
      return {
        ...state,
        getFileLoading: true,
        getFileSuccess: false,
        getFileFailure: false,
        getFileError: null,
      };
    case FILE.GET_RECENT_FILE_SUCCESS:
      return {
        ...state,
        getFileLoading: true,
        getFileSuccess: false,
        getFileFailure: false,
        recentFile: action.payload,
        getFileError: null,
      };
    case FILE.GET_RECENT_FILE_FAILURE:
      return {
        ...state,
        getFileLoading: false,
        getFileSuccess: false,
        getFileFailure: true,
        getFileError: action.payload,
      };
    case FILE.GET_FAVORITE_FILE_REQUEST:
      return {
        ...state,
        getFavoriteFileLoading: true,
        getFavoriteFileSuccess: false,
        getFavoriteFileFailure: false,
        getFavoriteFileError: null,
      };
    case FILE.GET_FAVORITE_FILE_SUCCESS:
      return {
        ...state,
        getFavoriteFileLoading: false,
        getFavoriteFileSuccess: true,
        getFavoriteFileFailure: false,
        favoriteFile: action.payload,
        getFavoriteFileError: null,
      };
    case FILE.GET_FAVORITE_FILE_FAILURE:
      return {
        ...state,
        getFavoriteFileLoading: false,
        getFavoriteFileSuccess: false,
        getFavoriteFileFailure: true,
        getFavoriteFileError: null,
        getFileError: action.payload,
      };
    case FILE.ADD_REMOVE_FAVORITE_FILE_REQUEST:
      return {
        ...state,
        addRemoveFavoriteFileLoading: true,
        addRemoveFavoriteFileSuccess: false,
        addRemoveFavoriteFileFailure: false,
        addRemoveFavoriteFileError: null,
      };
    case FILE.ADD_REMOVE_FAVORITE_FILE_SUCCESS:
      let favFile = state.fileList;
      var a = action.payload.isActive;

      for (var i = 0; i < favFile?.length; i++) {
        if (
          favFile[i].orgnizationDocumentId ===
          action.payload?.orgnizationDocumentId
        ) {
          favFile[i] = { ...favFile[i], isFav: a };
        }
      }
      return {
        ...state,
        addRemoveFavoriteFileLoading: false,
        addRemoveFavoriteFileSuccess: true,
        addRemoveFavoriteFileFailure: false,
        addRemoveFavoriteFileError: null,
        favoriteFile: favFile,
      };
    case FILE.ADD_REMOVE_FAVORITE_FILE_FAILURE:
      return {
        ...state,
        addRemoveFavoriteFileLoading: false,
        addRemoveFavoriteFileSuccess: false,
        addRemoveFavoriteFileFailure: true,
        addRemoveFavoriteFileError: action.payload,
      };
    case FILE.DELETE_FILE_REQUEST:
      return {
        ...state,
        deleteFileLoading: true,
        deleteFileSuccess: false,
        deleteFileFailure: false,
        deleteFileError: null,
      };
    case FILE.DELETE_FILE_SUCCESS:
      let delfile = state.fileList;
      let payload = delfile.filter(
        (item) => item.orgnizationDocumentId != action.payload
      );
      return {
        ...state,
        deleteFileLoading: false,
        deleteFileSuccess: true,
        deleteFileFailure: false,
        deleteFileError: null,
        fileList: payload,
      };
    case FILE.DELETE_FILE_FAILURE:
      return {
        ...state,
        deleteFileLoading: false,
        deleteFileSuccess: false,
        deleteFileFailure: true,
        deleteFileError: action.payload,
      };
    case FILE.GET_DELETED_FILE_REQUEST:
      return {
        ...state,
        getFileLoading: true,
        getFileSuccess: false,
        getFileFailure: false,
        getFileError: null,
      };
    case FILE.GET_DELETED_FILE_SUCCESS:
      return {
        ...state,
        getFileLoading: true,
        getFileSuccess: false,
        getFileFailure: false,
        deletedFile: action.payload,
        getFileError: null,
      };
    case FILE.GET_DELETED_FILE_FAILURE:
      return {
        ...state,
        getFileLoading: false,
        getFileSuccess: false,
        getFileFailure: true,
        getFileError: action.payload,
      };
    case FILE.SEARCH_FILE_SUCCESS:
      var filterDat = [];
      if (state.dateSearch === "") {
        filterDat = state.fileListArray.filter((item) => {
          var name = item.title.toLowerCase();
          var find = action.payload.toLowerCase();
          return name.startsWith(find);
        });
        // console.log(action.payload,"yes");
      } else {
        filterDat = state.fileListSearchDate.filter((item) => {
          var name = item.title.toLowerCase();
          var find = action.payload.toLowerCase();
          return name.startsWith(find);
        });
      }
      // console.log(action.payload,"check");
      return {
        ...state,
        getFileLoading: false,
        getFileSuccess: true,
        getFileFailure: false,
        getFileError: null,
        fileList: filterDat,
        fileListSearchWord: filterDat,
        wordSearch: action.payload,
      };
    case FILE.SEARCH_DATE_FILE_SUCCESS:
      var filterData = [];
      if (state.wordSearch === "") {
        filterData = state.fileListArray.filter((item) => {
          var name = item.date;
          var find = action.payload;
          return name.startsWith(find);
        });
        // console.log(action.payload,"yes");
      } else {
        filterData = state.fileListSearchWord.filter((item) => {
          var name = item.title.toLowerCase();
          var find = action.payload.toLowerCase();
          return name.startsWith(find);
        });
      }
      // console.log(action.payload,"check");

      return {
        ...state,
        getFileLoading: false,
        getFileSuccess: true,
        getFileFailure: false,
        getFileError: null,
        fileList: filterData,
        fileListSearchDate: filterData,
        dateSearch: action.payload,
      };
    default:
      // var n = state.fileListArray;
      return {
        ...state,
        // fileList: n,
        fileListSearchDate: [],
        fileListSearchWord: [],
        dateSearch: "",
        wordSearch: "",
      };
  }
};
